export const requirementModule = 'requirement'
